module.exports = __webpack_public_path__ + "media/images/service/b_5-4e7b99449344efaf1a7238b0ec5f4d94.png";